<template>
  <div class="organization-tooltip-content">
    <p v-for="(organization, index) in organizations" :key="index">
      {{ organization }}
    </p>
  </div>
</template>

<script>
export default {
  name: "OrganizationTooltip",

  props: {
    value: {
      type: [String, Number],
      default: "-",
    },
    row: Object,
    column: Object,
  },

  computed: {
    organizations() {
      if (this.value == null || this.value === "") {
        return ["-"];
      }

      return String(this.value)
        .split(";")
        .map((item) => item.trim())
        .filter(Boolean);
    },
  },
};
</script>

<style scoped lang="less">
.organization-tooltip-content {
  display: flex;
  flex-direction: column;
  gap: 8px;
  max-width: 100%;
}
</style>
